import { render, staticRenderFns } from "./SalesOrderList.vue?vue&type=template&id=8260f6d6&scoped=true"
import script from "./SalesOrderList.vue?vue&type=script&lang=js"
export * from "./SalesOrderList.vue?vue&type=script&lang=js"
import style0 from "./SalesOrderList.vue?vue&type=style&index=0&id=8260f6d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8260f6d6",
  null
  
)

export default component.exports